import AccessToken from './AccessToken';

import { IAuthorizeMiddleware } from '../types';

const defaultOptions = <IAuthorizeMiddleware.Options>{
    closeWindow: false,
};

export default function (redirect_uri: string, options: IAuthorizeMiddleware.Options = defaultOptions): AccessToken {
    const path = window.location.pathname.replace(/^\/|\/$/g, '');
    redirect_uri = redirect_uri.replace(/^\/|\/$/g, '');

    if (path != redirect_uri) {
        return;
    }

    const hash = window.location.hash.replace(/^#?\/?/g, '');

    const data: any = hash.split('&').reduce(function (prev: any, curr: any, i: any, arr: any) {
        var p = curr.split('=');
        prev[decodeURIComponent(p[0])] = decodeURIComponent(p[1]).replace(/\+/g, ' ');
        return prev;
    }, {});

    if (!data.access_token) {
        const error = 'Authorization failed - no access token';
        console.error(error);
        throw new Error(error);
    }

    data.expires_in = parseInt(data.expires_in);

    (window.opener || window.parent).postMessage(
        {
            action: 'auth.success',
            payload: {
                access_token: data,
                state: data.state,
            },
        },
        window.location.protocol + '//' + window.location.host
    );

    if (options.closeWindow === true) {
        setTimeout(() => window.close(), 100);
    }

    return new AccessToken(data);
}
